import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useBusinessUnit } from "../../context/BusinessUnitContext";
import { isAdminRole, convertLegacyRole } from "../../constants/roles";

const AdminRoute = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const { currentRole } = useBusinessUnit();
  
  // Convert legacy roles and check if user has admin privileges
  const userRole = convertLegacyRole(user?.role);
  const buRole = convertLegacyRole(currentRole);
  
  const isAdmin = isAdminRole(userRole) || isAdminRole(buRole);
  
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return isAdmin ? children : <Navigate to="/portal/dashboard" replace />;
};

export default AdminRoute; 